# all template "partials" (includes) that are used client side, must be mapped here
# on the left, the name of the include, on the right, the path to the include relative to this file
module.exports =
  "shared_load-more-deals-cui": require '../../shared/load-more-deals-cui.html.mustache'
  "shared_load-more-deals-legacy": require '../../shared/load-more-deals-legacy.html.mustache'
  "shared_load-more-deals-attributes": require '../../shared/load-more-deals-attributes.html.mustache'
  "shared_load-more-deals-attributes-filter": require '../../shared/load-more-deals-attributes-filter.html.mustache'
